import { useSearchParams } from "react-router-dom";
import { getSelectedAdvisor } from "web_myplann/Advisor/Utils/getSelectedAdvisor";
import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { getTypedParam } from "web_myplann/Shared/Utils/getTypedParam";

export const useAdvisorSelection = (
	advisors: AgentAssignedListItemResponseDTO[],
) => {
	const [searchParams, setSearchParams] = useSearchParams();

	return {
		selected: getSelectedAdvisor(
			advisors,
			getTypedParam(searchParams, "uid", String),
		),
		selectAdvisor: (uid: string) => setSearchParams({ uid }, { replace: true }),
		clearSelection: () => setSearchParams({}, { replace: true }),
	};
};
